import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, Validators } from '@angular/forms';
@Directive({
  selector: '[PasswordMatcher]',
  providers: [
    {
      provide:NG_VALIDATORS,
      useExisting:PasswordMatcherDirective,
      multi:true
    }
  ]
})
export class PasswordMatcherDirective implements Validator{
  @Input() PasswordMatcher:AbstractControl;
  validate(control: AbstractControl): ValidationErrors {
    const confirmPassword=control.value
    const password=this.PasswordMatcher.value
    if(confirmPassword!=password)
      return {'passwordMismatch':true}
    return null
  }

}
